<!-- 单账号策略-->
<template>
<div>
    <easyCruds
    ref="mainTable"
    :tableInfo="mainTable"
    @mainTableReload="mainTableReload"
    @failStrategyTimes="failStrategyTimes"
    @unfrozen="unfrozen"
  >
  </easyCruds>
  <loginFailureStrategySettingView
  type="ACCOUNT"
  ref="loginFailureStrategySettingView"
  :isShow="loginFailureStrategySettingView.isShow"
  :id="loginFailureStrategySettingView.id"
  ></loginFailureStrategySettingView>
  </div>
</template>
<script>
import loginFailureStrategySettingView from './loginFailureStrategySettingView'
export default {
  data() {
    return {
      loginFailureStrategySettingView: {
        isShow: {
          show: false
        },
        id: null
      },
      mainTable: {
        header: { title: '单账号策略', icon: 'fa fa-key' },
        buttonSetting: {
          allowAdd: false,
          allowEdit: false,
          allowView: false,
          allowDelete: false

        },
        table: {
          loading: false,
          height: 650,
          stripe: true,
          conditionLabelWidth: 'auto',
          selection: true,
          index: false,
          columns: [{
            label: '登录名',
            isSearchCondition: true,
            prop: 'loginName'
          }, {
            label: '姓名',
            prop: 'name',
            isSearchCondition: true,
            type: 'input'
          }, {
            prop: 'status',
            label: '状态',
            isTag: true,
            type: 'select',
            isSearchCondition: true,
            tagFilter: function(e) {
              if (e === 1) {
                return { data: '正常', type: 'success' }
              } else if (e === 2) {
                return { data: '冻结', type: 'warning' }
              } else {
                return { data: '过期', type: 'warning' }
              }
            },
            dicData: [{
              label: '正常',
              value: 1
            }, {
              label: '冻结',
              value: 2
            }, {
              label: '过期',
              value: 3
            }]
          }],
          operation: {
            width: 220,
            operations: [{
              clickEvent: 'failStrategyTimes',
              title: ' 设置',
              type: 'primary',
              icon: 'fa fa-cogs fa-x'
            }, {
              clickEvent: 'unfrozen',
              type: 'primary',
              title: ' 解冻',
              icon: 'fa fa-unlock fa-x'
            }]
          },
          tableData: [],
          paging: {
            currentPage: 1,
            pageSizes: [15, 20, 25, 30],
            pageSize: 15,
            total: 0
          },
          reload: 'mainTableReload',
          reloadConditions: {},
          addDefultValue: {}
        }
      }

    }
  },
  mounted() {
    this.mainTableReload()
  },
  components: {
    loginFailureStrategySettingView
  },
  methods: {
    mainTableReload(params = {}) {
      this.mainTable.table.loading = true
      let { pageNum = 1, pageSize = 10 } = params
      this.$http.post('/account/query', { 'entity': params }, { params: { pageNum, pageSize }}).then(
        response => {
          this.mainTable.table.loading = false
          this.mainTable.table.tableData = response.data.records
          this.mainTable.table.paging.total = response.data.total || response.data.records.length
        }
      ).catch(
        error => {
          this.mainTable.table.loading = false
          this.$message.error(error.msg)
        }
      )
    },
    failStrategyTimes(index, row) {
      this.loginFailureStrategySettingView.isShow.show = true
      this.loginFailureStrategySettingView.id = row.id
      this.$refs['loginFailureStrategySettingView'].Initialize()
    },
    // 解冻由于触发策略造成的冻结,永久冻结请通过账号管理解冻
    unfrozen(index, row) {
      this.$http.post('/login-failure-strategy/unfrozen', null, {
        params: { accountId: row.id }
      }).then(response => this.$message.success(response.msg)).catch(error => this.$message.error(error.msg))
    }
  }
}
</script>
